import { AxiosRequestConfig } from 'axios';

import api from './base';
import isInvenzi from '_/helpers/isInvenzi';
import { appConfig } from '_/config/app';

interface NotificationTokenData {
  deviceId: string;
  token: string;
  userId: string;
  type: string;
  spaceManagementEnabled?: boolean;
}

class NotificationTokens {
  private spaceManagementNotification = '/user-tokens';

  public async getAllNotificationTokens(params: any, config?: AxiosRequestConfig) {
    const { data } = await api.get('/notification-tokens', {
      ...config,
      params: {
        ...params,
      },
    });
    if (data) {
      return data;
    } else {
      return undefined;
    }
  }

  public async getNotificationTokenById(id: string) {
    const { data } = await api.get(`/notification-tokens/${id}`);
    return data;
  }

  public async createNotificationToken({
    deviceId,
    token,
    userId,
    type,
    spaceManagementEnabled,
  }: NotificationTokenData) {
    const { data } = await api.post('/notification-tokens', {
      token,
      userId,
      type,
      deviceId,
    });
    // estava tendo problema ao tentar habilitar a notificaçao, despois investigar
    if (isInvenzi() && spaceManagementEnabled) {
      await api.post(
        this.spaceManagementNotification,
        { token, userId, type, deviceId },
        {
          baseURL: appConfig.spaceManagement.spaceManagementApi,
        }
      );
    }

    return data;
  }

  public async updateNotificationToken({
    deviceId,
    token,
    userId,
    type,
    spaceManagementEnabled,
  }: NotificationTokenData) {
    await api.patch(`/notification-tokens/${deviceId}`, {
      token,
      userId,
      type,
    });
    if (isInvenzi() && spaceManagementEnabled) {
      await api.patch(
        `${this.spaceManagementNotification}/${deviceId}`,
        { token, userId, type },
        {
          baseURL: appConfig.spaceManagement.spaceManagementApi,
        }
      );
    }
  }

  public async deleteNotificationToken(
    id: string,
    deviceId?: string,
    spaceManagementEnabled?: boolean
  ) {
    try {
      await api.delete(`/notification-tokens/${id}`);
      if (isInvenzi() && spaceManagementEnabled) {
        await api.delete(`${this.spaceManagementNotification}`, {
          baseURL: appConfig.spaceManagement.spaceManagementApi,
          params: {
            deviceId,
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
}

export default new NotificationTokens();
